var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showHeader)?_c('h1',{staticClass:"mb-3"},[_vm._v("Datenschutzbestimmungen")]):_vm._e(),_c('static-content',{attrs:{"which":"privacy-policy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }